import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'inline-block',
      overflow: 'hidden',
      verticalAlign: 'bottom',
      padding: theme.spacing(0, 0.25),

      backgroundColor: COLORS.primary.silver,
      borderRadius: theme.shape.borderRadiusSmall,
      color: COLORS.primary.active,

      '&$highlighted': {
        backgroundColor: COLORS.primary.light,
      },
    },
    highlighted: {},

    content: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  }),
  { name: 'VariableNode' }
);
